import React from 'react';
import { PillarPage } from '../components/PillarPage';
import { cuerpoPage } from '../data/pages/cuerpo';
export function Cuerpo() {
  return <PillarPage content={cuerpoPage} data-id="element-259" data-mp="1l4vgy6z0h271" />;
}